import React, {PureComponent} from 'react'
import Store from 'Store'
import {inject, observer} from 'mobx-react'
import {loading} from 'elements/Loading'
import {Form} from 'components'
import {FieldType} from 'elements'
import {rules} from 'helpers/Validation'
import PassengerCategory, {TypePassenger} from '../Model'
import {t} from 'helpers/i18n'

interface Props {
  store?: Store
  match: any
  passengerCategory: PassengerCategory
}

@inject('store')
@loading<Props>(props => [
  props.match.params.id
  ? props.store!.passengerCategories.read(props.match.params.id).then(passengerCategory => ({passengerCategory}))
    : undefined
])
export default class extends PureComponent<Props, object> {

  private typePassengers = Object.entries(TypePassenger).map((item) => {
    console.log('name', item[1])
    return ({
      name: t(`typePassenger:${item[1]}`),
      value: item[1]
    })})

  private fields = [
      {
        name: 'name',
        type: FieldType.Text,
        rules: rules()
          .string()
          .required(),
        size: 4
      },
      {
        name: 'code',
        type: FieldType.Text,
        rules: rules()
          .string()
          .required(),
        size: 6
      },
      {
        name: 'description',
        type: FieldType.TextArea,
        rules: rules()
          .string(),
        size: 6
      },
    {
      name: 'type',
      type: FieldType.Select,
      rules: rules().string().required(),
      options: this.typePassengers,
      size: 4
    }
    ]

  render() {
    const {passengerCategory} = this.props
    const passengercategories = this.props.store!.passengerCategories
    return (
        <div>
          <Form
            delete={this.props.match.params.id}
            loading={['post@passengercategories/', 'put@passengercategories/', 'delete@passengercategories/']}
            fields={this.fields}
            values={passengerCategory}
            store={passengercategories}
          />
        </div>
      )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/PassengerCategories/container/PassengerCategoriesForm.tsx